function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = function(cb, mod) {
    return function __require() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
// ../../../node_modules/@wagmi/chains/dist/index.js
var require_dist = __commonJS({
    "../../../node_modules/@wagmi/chains/dist/index.js": function(exports) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var arbitrum = {
            id: 42161,
            name: "Arbitrum One",
            network: "arbitrum",
            nativeCurrency: {
                name: "Ether",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: {
                alchemy: {
                    http: [
                        "https://arb-mainnet.g.alchemy.com/v2"
                    ],
                    webSocket: [
                        "wss://arb-mainnet.g.alchemy.com/v2"
                    ]
                },
                infura: {
                    http: [
                        "https://arbitrum-mainnet.infura.io/v3"
                    ],
                    webSocket: [
                        "wss://arbitrum-mainnet.infura.io/ws/v3"
                    ]
                },
                default: {
                    http: [
                        "https://arb1.arbitrum.io/rpc"
                    ]
                },
                public: {
                    http: [
                        "https://arb1.arbitrum.io/rpc"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Arbiscan",
                    url: "https://arbiscan.io"
                },
                default: {
                    name: "Arbiscan",
                    url: "https://arbiscan.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 7654707
                }
            }
        };
        var arbitrumGoerli = {
            id: 421613,
            name: "Arbitrum Goerli",
            network: "arbitrum-goerli",
            nativeCurrency: {
                name: "Arbitrum Goerli Ether",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: {
                alchemy: {
                    http: [
                        "https://arb-goerli.g.alchemy.com/v2"
                    ],
                    webSocket: [
                        "wss://arb-goerli.g.alchemy.com/v2"
                    ]
                },
                infura: {
                    http: [
                        "https://arbitrum-goerli.infura.io/v3"
                    ],
                    webSocket: [
                        "wss://arbitrum-goerli.infura.io/ws/v3"
                    ]
                },
                default: {
                    http: [
                        "https://goerli-rollup.arbitrum.io/rpc"
                    ]
                },
                public: {
                    http: [
                        "https://goerli-rollup.arbitrum.io/rpc"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Arbiscan",
                    url: "https://goerli.arbiscan.io/"
                },
                default: {
                    name: "Arbiscan",
                    url: "https://goerli.arbiscan.io/"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 88114
                }
            },
            testnet: true
        };
        var aurora = {
            id: 1313161554,
            name: "Aurora",
            network: "aurora",
            nativeCurrency: {
                decimals: 18,
                name: "Ether",
                symbol: "ETH"
            },
            rpcUrls: {
                infura: {
                    http: [
                        "https://aurora-mainnet.infura.io/v3"
                    ]
                },
                default: {
                    http: [
                        "https://mainnet.aurora.dev"
                    ]
                },
                public: {
                    http: [
                        "https://mainnet.aurora.dev"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Aurorascan",
                    url: "https://aurorascan.dev"
                },
                default: {
                    name: "Aurorascan",
                    url: "https://aurorascan.dev"
                }
            }
        };
        var auroraTestnet = {
            id: 1313161555,
            name: "Aurora Testnet",
            network: "aurora-testnet",
            nativeCurrency: {
                decimals: 18,
                name: "Ether",
                symbol: "ETH"
            },
            rpcUrls: {
                infura: {
                    http: [
                        "https://aurora-testnet.infura.io/v3"
                    ]
                },
                default: {
                    http: [
                        "https://testnet.aurora.dev"
                    ]
                },
                public: {
                    http: [
                        "https://testnet.aurora.dev"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Aurorascan",
                    url: "https://testnet.aurorascan.dev"
                },
                default: {
                    name: "Aurorascan",
                    url: "https://testnet.aurorascan.dev"
                }
            },
            testnet: true
        };
        var avalanche = {
            id: 43114,
            name: "Avalanche",
            network: "avalanche",
            nativeCurrency: {
                decimals: 18,
                name: "Avalanche",
                symbol: "AVAX"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://api.avax.network/ext/bc/C/rpc"
                    ]
                },
                public: {
                    http: [
                        "https://api.avax.network/ext/bc/C/rpc"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "SnowTrace",
                    url: "https://snowtrace.io"
                },
                default: {
                    name: "SnowTrace",
                    url: "https://snowtrace.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 11907934
                }
            }
        };
        var avalancheFuji = {
            id: 43113,
            name: "Avalanche Fuji",
            network: "avalanche-fuji",
            nativeCurrency: {
                decimals: 18,
                name: "Avalanche Fuji",
                symbol: "AVAX"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://api.avax-test.network/ext/bc/C/rpc"
                    ]
                },
                public: {
                    http: [
                        "https://api.avax-test.network/ext/bc/C/rpc"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "SnowTrace",
                    url: "https://testnet.snowtrace.io"
                },
                default: {
                    name: "SnowTrace",
                    url: "https://testnet.snowtrace.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 7096959
                }
            },
            testnet: true
        };
        var baseGoerli = {
            id: 84531,
            network: "base-goerli",
            name: "Base Goerli",
            nativeCurrency: {
                name: "Base Goerli",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://goerli.base.org"
                    ]
                },
                public: {
                    http: [
                        "https://goerli.base.org"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Basescan",
                    url: "https://goerli.basescan.org"
                },
                default: {
                    name: "Basescan",
                    url: "https://goerli.basescan.org"
                }
            },
            testnet: true
        };
        var bronos = {
            id: 1039,
            name: "Bronos",
            network: "bronos",
            nativeCurrency: {
                decimals: 18,
                name: "BRO",
                symbol: "BRO"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://evm.bronos.org"
                    ]
                },
                public: {
                    http: [
                        "https://evm.bronos.org"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "BronoScan",
                    url: "https://broscan.bronos.org"
                }
            }
        };
        var bronosTestnet = {
            id: 1038,
            name: "Bronos Testnet",
            network: "bronos-testnet",
            nativeCurrency: {
                decimals: 18,
                name: "Bronos Coin",
                symbol: "tBRO"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://evm-testnet.bronos.org"
                    ]
                },
                public: {
                    http: [
                        "https://evm-testnet.bronos.org"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "BronoScan",
                    url: "https://tbroscan.bronos.org"
                }
            },
            testnet: true
        };
        var bsc = {
            id: 56,
            name: "BNB Smart Chain",
            network: "bsc",
            nativeCurrency: {
                decimals: 18,
                name: "BNB",
                symbol: "BNB"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://rpc.ankr.com/bsc"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.ankr.com/bsc"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "BscScan",
                    url: "https://bscscan.com"
                },
                default: {
                    name: "BscScan",
                    url: "https://bscscan.com"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 15921452
                }
            }
        };
        var bscTestnet = {
            id: 97,
            name: "Binance Smart Chain Testnet",
            network: "bsc-testnet",
            nativeCurrency: {
                decimals: 18,
                name: "BNB",
                symbol: "tBNB"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://bsc-testnet.public.blastapi.io"
                    ]
                },
                public: {
                    http: [
                        "https://bsc-testnet.public.blastapi.io"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "BscScan",
                    url: "https://testnet.bscscan.com"
                },
                default: {
                    name: "BscScan",
                    url: "https://testnet.bscscan.com"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 17422483
                }
            },
            testnet: true
        };
        var canto = {
            id: 7700,
            name: "Canto",
            network: "canto",
            nativeCurrency: {
                decimals: 18,
                name: "Canto",
                symbol: "CANTO"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://canto.slingshot.finance"
                    ]
                },
                public: {
                    http: [
                        "https://canto.slingshot.finance"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Canto EVM Explorer (Blockscout)",
                    url: "https://evm.explorer.canto.io"
                }
            }
        };
        var celo = {
            id: 42220,
            name: "Celo",
            network: "celo",
            nativeCurrency: {
                decimals: 18,
                name: "CELO",
                symbol: "CELO"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://forno.celo.org"
                    ]
                },
                infura: {
                    http: [
                        "https://celo-mainnet.infura.io/v3"
                    ]
                },
                public: {
                    http: [
                        "https://forno.celo.org"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Celo Explorer",
                    url: "https://explorer.celo.org/mainnet"
                },
                etherscan: {
                    name: "CeloScan",
                    url: "https://celoscan.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xcA11bde05977b3631167028862bE2a173976CA11",
                    blockCreated: 13112599
                }
            },
            testnet: false
        };
        var celoAlfajores = {
            id: 44787,
            name: "Alfajores",
            network: "celo-alfajores",
            nativeCurrency: {
                decimals: 18,
                name: "CELO",
                symbol: "A-CELO"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://alfajores-forno.celo-testnet.org"
                    ]
                },
                infura: {
                    http: [
                        "https://celo-alfajores.infura.io/v3"
                    ]
                },
                public: {
                    http: [
                        "https://alfajores-forno.celo-testnet.org"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Celo Explorer",
                    url: "https://explorer.celo.org/alfajores"
                },
                etherscan: {
                    name: "CeloScan",
                    url: "https://alfajores.celoscan.io/"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xcA11bde05977b3631167028862bE2a173976CA11",
                    blockCreated: 14569001
                }
            },
            testnet: true
        };
        var crossbell = {
            id: 3737,
            network: "crossbell",
            name: "Crossbell",
            nativeCurrency: {
                decimals: 18,
                name: "CSB",
                symbol: "CSB"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://rpc.crossbell.io"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.crossbell.io"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "CrossScan",
                    url: "https://scan.crossbell.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xBB9759009cDaC82774EfC84D94cD9F7440f75Fcf",
                    blockCreated: 23499787
                }
            }
        };
        var evmos = {
            id: 9001,
            name: "Evmos",
            network: "evmos",
            nativeCurrency: {
                decimals: 18,
                name: "Evmos",
                symbol: "EVMOS"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://eth.bd.evmos.org:8545"
                    ]
                },
                public: {
                    http: [
                        "https://eth.bd.evmos.org:8545"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Evmos Block Explorer",
                    url: "https://escan.live/"
                }
            }
        };
        var evmosTestnet = {
            id: 9e3,
            name: "Evmos Testnet",
            network: "evmos-testnet",
            nativeCurrency: {
                decimals: 18,
                name: "Evmos",
                symbol: "EVMOS"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://eth.bd.evmos.dev:8545"
                    ]
                },
                public: {
                    http: [
                        "https://eth.bd.evmos.dev:8545"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Evmos Testnet Block Explorer",
                    url: "https://evm.evmos.dev/"
                }
            }
        };
        var fantom = {
            id: 250,
            name: "Fantom",
            network: "fantom",
            nativeCurrency: {
                decimals: 18,
                name: "Fantom",
                symbol: "FTM"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://rpc.ankr.com/fantom"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.ankr.com/fantom"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "FTMScan",
                    url: "https://ftmscan.com"
                },
                default: {
                    name: "FTMScan",
                    url: "https://ftmscan.com"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 33001987
                }
            }
        };
        var fantomTestnet = {
            id: 4002,
            name: "Fantom Testnet",
            network: "fantom-testnet",
            nativeCurrency: {
                decimals: 18,
                name: "Fantom",
                symbol: "FTM"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://rpc.testnet.fantom.network"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.testnet.fantom.network"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "FTMScan",
                    url: "https://testnet.ftmscan.com"
                },
                default: {
                    name: "FTMScan",
                    url: "https://testnet.ftmscan.com"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 8328688
                }
            }
        };
        var filecoin = {
            id: 314,
            name: "Filecoin Mainnet",
            network: "filecoin-mainnet",
            nativeCurrency: {
                decimals: 18,
                name: "filecoin",
                symbol: "FIL"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://api.node.glif.io/rpc/v1"
                    ]
                },
                public: {
                    http: [
                        "https://api.node.glif.io/rpc/v1"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Filfox",
                    url: "https://filfox.info/en"
                },
                filscan: {
                    name: "Filscan",
                    url: "https://filscan.io"
                },
                filscout: {
                    name: "Filscout",
                    url: "https://filscout.io/en"
                },
                glif: {
                    name: "Glif",
                    url: "https://explorer.glif.io"
                }
            }
        };
        var filecoinCalibration = {
            id: 314159,
            name: "Filecoin Calibration",
            network: "filecoin-calibration",
            nativeCurrency: {
                decimals: 18,
                name: "testnet filecoin",
                symbol: "tFIL"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://api.calibration.node.glif.io/rpc/v1"
                    ]
                },
                public: {
                    http: [
                        "https://api.calibration.node.glif.io/rpc/v1"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Filscan",
                    url: "https://calibration.filscan.io"
                }
            }
        };
        var filecoinHyperspace = {
            id: 3141,
            name: "Filecoin Hyperspace",
            network: "filecoin-hyperspace",
            nativeCurrency: {
                decimals: 18,
                name: "testnet filecoin",
                symbol: "tFIL"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://api.hyperspace.node.glif.io/rpc/v1"
                    ]
                },
                public: {
                    http: [
                        "https://api.hyperspace.node.glif.io/rpc/v1"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Filfox",
                    url: "https://hyperspace.filfox.info/en"
                },
                filscan: {
                    name: "Filscan",
                    url: "https://hyperspace.filscan.io"
                }
            }
        };
        var foundry = {
            id: 31337,
            name: "Foundry",
            network: "foundry",
            nativeCurrency: {
                decimals: 18,
                name: "Ether",
                symbol: "ETH"
            },
            rpcUrls: {
                default: {
                    http: [
                        "http://127.0.0.1:8545"
                    ]
                },
                public: {
                    http: [
                        "http://127.0.0.1:8545"
                    ]
                }
            }
        };
        var iotex = {
            id: 4689,
            name: "IoTeX",
            network: "iotex",
            nativeCurrency: {
                decimals: 18,
                name: "IoTeX",
                symbol: "IOTX"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://babel-api.mainnet.iotex.io"
                    ],
                    webSocket: [
                        "wss://babel-api.mainnet.iotex.io"
                    ]
                },
                public: {
                    http: [
                        "https://babel-api.mainnet.iotex.io"
                    ],
                    webSocket: [
                        "wss://babel-api.mainnet.iotex.io"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "IoTeXScan",
                    url: "https://iotexscan.io"
                }
            }
        };
        var iotexTestnet = {
            id: 4690,
            name: "IoTeX Testnet",
            network: "iotex-testnet",
            nativeCurrency: {
                decimals: 18,
                name: "IoTeX",
                symbol: "IOTX"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://babel-api.testnet.iotex.io"
                    ],
                    webSocket: [
                        "wss://babel-api.testnet.iotex.io"
                    ]
                },
                public: {
                    http: [
                        "https://babel-api.testnet.iotex.io"
                    ],
                    webSocket: [
                        "wss://babel-api.testnet.iotex.io"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "IoTeXScan",
                    url: "https://testnet.iotexscan.io"
                }
            }
        };
        var goerli = {
            id: 5,
            network: "goerli",
            name: "Goerli",
            nativeCurrency: {
                name: "Goerli Ether",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: {
                alchemy: {
                    http: [
                        "https://eth-goerli.g.alchemy.com/v2"
                    ],
                    webSocket: [
                        "wss://eth-goerli.g.alchemy.com/v2"
                    ]
                },
                infura: {
                    http: [
                        "https://goerli.infura.io/v3"
                    ],
                    webSocket: [
                        "wss://goerli.infura.io/ws/v3"
                    ]
                },
                default: {
                    http: [
                        "https://rpc.ankr.com/eth_goerli"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.ankr.com/eth_goerli"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Etherscan",
                    url: "https://goerli.etherscan.io"
                },
                default: {
                    name: "Etherscan",
                    url: "https://goerli.etherscan.io"
                }
            },
            contracts: {
                ensRegistry: {
                    address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
                },
                ensUniversalResolver: {
                    address: "0x687c30Cc44bFA39A1449e86E172BF002E7b3f0b0",
                    blockCreated: 7725078
                },
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 6507670
                }
            },
            testnet: true
        };
        var gnosis = {
            id: 100,
            name: "Gnosis",
            network: "gnosis",
            nativeCurrency: {
                decimals: 18,
                name: "Gnosis",
                symbol: "xDAI"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://rpc.gnosischain.com"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.gnosischain.com"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Gnosisscan",
                    url: "https://gnosisscan.io/"
                },
                default: {
                    name: "Gnosis Chain Explorer",
                    url: "https://blockscout.com/xdai/mainnet/"
                }
            }
        };
        var gnosisChiado = {
            id: 10200,
            name: "Gnosis Chiado",
            network: "chiado",
            nativeCurrency: {
                decimals: 18,
                name: "Gnosis",
                symbol: "xDAI"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://rpc.chiadochain.net"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.chiadochain.net"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Blockscout",
                    url: "https://blockscout.chiadochain.net"
                }
            }
        };
        var hardhat = {
            id: 31337,
            name: "Hardhat",
            network: "hardhat",
            nativeCurrency: {
                decimals: 18,
                name: "Ether",
                symbol: "ETH"
            },
            rpcUrls: {
                default: {
                    http: [
                        "http://127.0.0.1:8545"
                    ]
                },
                public: {
                    http: [
                        "http://127.0.0.1:8545"
                    ]
                }
            }
        };
        var harmonyOne = {
            id: 16666e5,
            name: "Harmony One",
            network: "harmony",
            nativeCurrency: {
                name: "Harmony",
                symbol: "ONE",
                decimals: 18
            },
            rpcUrls: {
                public: {
                    http: [
                        "https://rpc.ankr.com/harmony"
                    ]
                },
                default: {
                    http: [
                        "https://rpc.ankr.com/harmony"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Harmony Explorer",
                    url: "https://explorer.harmony.one"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 24185753
                }
            }
        };
        var localhost = {
            id: 1337,
            name: "Localhost",
            network: "localhost",
            nativeCurrency: {
                decimals: 18,
                name: "Ether",
                symbol: "ETH"
            },
            rpcUrls: {
                default: {
                    http: [
                        "http://127.0.0.1:8545"
                    ]
                },
                public: {
                    http: [
                        "http://127.0.0.1:8545"
                    ]
                }
            }
        };
        var mainnet = {
            id: 1,
            network: "homestead",
            name: "Ethereum",
            nativeCurrency: {
                name: "Ether",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: {
                alchemy: {
                    http: [
                        "https://eth-mainnet.g.alchemy.com/v2"
                    ],
                    webSocket: [
                        "wss://eth-mainnet.g.alchemy.com/v2"
                    ]
                },
                infura: {
                    http: [
                        "https://mainnet.infura.io/v3"
                    ],
                    webSocket: [
                        "wss://mainnet.infura.io/ws/v3"
                    ]
                },
                default: {
                    http: [
                        "https://cloudflare-eth.com"
                    ]
                },
                public: {
                    http: [
                        "https://cloudflare-eth.com"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Etherscan",
                    url: "https://etherscan.io"
                },
                default: {
                    name: "Etherscan",
                    url: "https://etherscan.io"
                }
            },
            contracts: {
                ensRegistry: {
                    address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
                },
                ensUniversalResolver: {
                    address: "0x74E20Bd2A1fE0cdbe45b9A1d89cb7e0a45b36376",
                    blockCreated: 16172161
                },
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 14353601
                }
            }
        };
        var metis = {
            id: 1088,
            name: "Metis",
            network: "andromeda",
            nativeCurrency: {
                decimals: 18,
                name: "Metis",
                symbol: "METIS"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://andromeda.metis.io/?owner=1088"
                    ]
                },
                public: {
                    http: [
                        "https://andromeda.metis.io/?owner=1088"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Andromeda Explorer",
                    url: "https://andromeda-explorer.metis.io"
                }
            }
        };
        var metisGoerli = {
            id: 599,
            name: "Metis Goerli",
            network: "metis-goerli",
            nativeCurrency: {
                decimals: 18,
                name: "Metis Goerli",
                symbol: "METIS"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://goerli.gateway.metisdevops.link"
                    ]
                },
                public: {
                    http: [
                        "https://goerli.gateway.metisdevops.link"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Metis Goerli Explorer",
                    url: "https://goerli.explorer.metisdevops.link"
                }
            }
        };
        var moonbaseAlpha = {
            id: 1287,
            name: "Moonbase Alpha",
            network: "moonbase-alpha",
            nativeCurrency: {
                decimals: 18,
                name: "DEV",
                symbol: "DEV"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://rpc.api.moonbase.moonbeam.network"
                    ],
                    webSocket: [
                        "wss://wss.api.moonbase.moonbeam.network"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.api.moonbase.moonbeam.network"
                    ],
                    webSocket: [
                        "wss://wss.api.moonbase.moonbeam.network"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Moonscan",
                    url: "https://moonbase.moonscan.io"
                },
                etherscan: {
                    name: "Moonscan",
                    url: "https://moonbase.moonscan.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xcA11bde05977b3631167028862bE2a173976CA11",
                    blockCreated: 1850686
                }
            },
            testnet: true
        };
        var moonbeam = {
            id: 1284,
            name: "Moonbeam",
            network: "moonbeam",
            nativeCurrency: {
                decimals: 18,
                name: "GLMR",
                symbol: "GLMR"
            },
            rpcUrls: {
                public: {
                    http: [
                        "https://moonbeam.public.blastapi.io"
                    ],
                    webSocket: [
                        "wss://moonbeam.public.blastapi.io"
                    ]
                },
                default: {
                    http: [
                        "https://moonbeam.public.blastapi.io"
                    ],
                    webSocket: [
                        "wss://moonbeam.public.blastapi.io"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Moonscan",
                    url: "https://moonscan.io"
                },
                etherscan: {
                    name: "Moonscan",
                    url: "https://moonscan.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xcA11bde05977b3631167028862bE2a173976CA11",
                    blockCreated: 609002
                }
            },
            testnet: false
        };
        var moonriver = {
            id: 1285,
            name: "Moonriver",
            network: "moonriver",
            nativeCurrency: {
                decimals: 18,
                name: "MOVR",
                symbol: "MOVR"
            },
            rpcUrls: {
                public: {
                    http: [
                        "https://moonriver.public.blastapi.io"
                    ],
                    webSocket: [
                        "wss://moonriver.public.blastapi.io"
                    ]
                },
                default: {
                    http: [
                        "https://moonriver.public.blastapi.io"
                    ],
                    webSocket: [
                        "wss://moonriver.public.blastapi.io"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Moonscan",
                    url: "https://moonriver.moonscan.io"
                },
                etherscan: {
                    name: "Moonscan",
                    url: "https://moonriver.moonscan.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xcA11bde05977b3631167028862bE2a173976CA11",
                    blockCreated: 1597904
                }
            },
            testnet: false
        };
        var okc = {
            id: 66,
            name: "OKC",
            network: "okc",
            nativeCurrency: {
                decimals: 18,
                name: "OKT",
                symbol: "OKT"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://exchainrpc.okex.org"
                    ]
                },
                public: {
                    http: [
                        "https://exchainrpc.okex.org"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "oklink",
                    url: "https://www.oklink.com/okc"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 10364792
                }
            }
        };
        var optimism = {
            id: 10,
            name: "Optimism",
            network: "optimism",
            nativeCurrency: {
                name: "Ether",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: {
                alchemy: {
                    http: [
                        "https://opt-mainnet.g.alchemy.com/v2"
                    ],
                    webSocket: [
                        "wss://opt-mainnet.g.alchemy.com/v2"
                    ]
                },
                infura: {
                    http: [
                        "https://optimism-mainnet.infura.io/v3"
                    ],
                    webSocket: [
                        "wss://optimism-mainnet.infura.io/ws/v3"
                    ]
                },
                default: {
                    http: [
                        "https://mainnet.optimism.io"
                    ]
                },
                public: {
                    http: [
                        "https://mainnet.optimism.io"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Etherscan",
                    url: "https://optimistic.etherscan.io"
                },
                default: {
                    name: "Optimism Explorer",
                    url: "https://explorer.optimism.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 4286263
                }
            }
        };
        var optimismGoerli = {
            id: 420,
            name: "Optimism Goerli",
            network: "optimism-goerli",
            nativeCurrency: {
                name: "Goerli Ether",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: {
                alchemy: {
                    http: [
                        "https://opt-goerli.g.alchemy.com/v2"
                    ],
                    webSocket: [
                        "wss://opt-goerli.g.alchemy.com/v2"
                    ]
                },
                infura: {
                    http: [
                        "https://optimism-goerli.infura.io/v3"
                    ],
                    webSocket: [
                        "wss://optimism-goerli.infura.io/ws/v3"
                    ]
                },
                default: {
                    http: [
                        "https://goerli.optimism.io"
                    ]
                },
                public: {
                    http: [
                        "https://goerli.optimism.io"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Etherscan",
                    url: "https://goerli-optimism.etherscan.io"
                },
                default: {
                    name: "Etherscan",
                    url: "https://goerli-optimism.etherscan.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 49461
                }
            },
            testnet: true
        };
        var polygon = {
            id: 137,
            name: "Polygon",
            network: "matic",
            nativeCurrency: {
                name: "MATIC",
                symbol: "MATIC",
                decimals: 18
            },
            rpcUrls: {
                alchemy: {
                    http: [
                        "https://polygon-mainnet.g.alchemy.com/v2"
                    ],
                    webSocket: [
                        "wss://polygon-mainnet.g.alchemy.com/v2"
                    ]
                },
                infura: {
                    http: [
                        "https://polygon-mainnet.infura.io/v3"
                    ],
                    webSocket: [
                        "wss://polygon-mainnet.infura.io/ws/v3"
                    ]
                },
                default: {
                    http: [
                        "https://polygon-rpc.com"
                    ]
                },
                public: {
                    http: [
                        "https://polygon-rpc.com"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "PolygonScan",
                    url: "https://polygonscan.com"
                },
                default: {
                    name: "PolygonScan",
                    url: "https://polygonscan.com"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 25770160
                }
            }
        };
        var polygonMumbai = {
            id: 80001,
            name: "Polygon Mumbai",
            network: "maticmum",
            nativeCurrency: {
                name: "MATIC",
                symbol: "MATIC",
                decimals: 18
            },
            rpcUrls: {
                alchemy: {
                    http: [
                        "https://polygon-mumbai.g.alchemy.com/v2"
                    ],
                    webSocket: [
                        "wss://polygon-mumbai.g.alchemy.com/v2"
                    ]
                },
                infura: {
                    http: [
                        "https://polygon-mumbai.infura.io/v3"
                    ],
                    webSocket: [
                        "wss://polygon-mumbai.infura.io/ws/v3"
                    ]
                },
                default: {
                    http: [
                        "https://matic-mumbai.chainstacklabs.com"
                    ]
                },
                public: {
                    http: [
                        "https://matic-mumbai.chainstacklabs.com"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "PolygonScan",
                    url: "https://mumbai.polygonscan.com"
                },
                default: {
                    name: "PolygonScan",
                    url: "https://mumbai.polygonscan.com"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 25770160
                }
            },
            testnet: true
        };
        var polygonZkEvmTestnet = {
            id: 1422,
            name: "Polygon zkEVM Testnet",
            network: "polygon-zkevm-testnet",
            nativeCurrency: {
                name: "Ether",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://rpc.public.zkevm-test.net"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.public.zkevm-test.net"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Blockscout",
                    url: "https://explorer.public.zkevm-test.net"
                }
            },
            testnet: true
        };
        var sepolia = {
            id: 11155111,
            network: "sepolia",
            name: "Sepolia",
            nativeCurrency: {
                name: "Sepolia Ether",
                symbol: "SEP",
                decimals: 18
            },
            rpcUrls: {
                infura: {
                    http: [
                        "https://sepolia.infura.io/v3"
                    ],
                    webSocket: [
                        "wss://sepolia.infura.io/ws/v3"
                    ]
                },
                default: {
                    http: [
                        "https://rpc.sepolia.org"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.sepolia.org"
                    ]
                }
            },
            blockExplorers: {
                etherscan: {
                    name: "Etherscan",
                    url: "https://sepolia.etherscan.io"
                },
                default: {
                    name: "Etherscan",
                    url: "https://sepolia.etherscan.io"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xca11bde05977b3631167028862be2a173976ca11",
                    blockCreated: 6507670
                }
            },
            testnet: true
        };
        var taraxa = {
            id: 841,
            name: "Taraxa Mainnet",
            network: "taraxa",
            nativeCurrency: {
                name: "Tara",
                symbol: "TARA",
                decimals: 18
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://rpc.mainnet.taraxa.io"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.mainnet.taraxa.io"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Taraxa Explorer",
                    url: "https://explorer.mainnet.taraxa.io"
                }
            }
        };
        var taraxaTestnet = {
            id: 842,
            name: "Taraxa Testnet",
            network: "taraxa-testnet",
            nativeCurrency: {
                name: "Tara",
                symbol: "TARA",
                decimals: 18
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://rpc.testnet.taraxa.io"
                    ]
                },
                public: {
                    http: [
                        "https://rpc.testnet.taraxa.io"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Taraxa Explorer",
                    url: "https://explorer.testnet.taraxa.io"
                }
            },
            testnet: true
        };
        var telos = {
            id: 40,
            name: "Telos",
            network: "telos",
            nativeCurrency: {
                decimals: 18,
                name: "Telos",
                symbol: "TLOS"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://mainnet.telos.net/evm"
                    ]
                },
                public: {
                    http: [
                        "https://mainnet.telos.net/evm"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Teloscan",
                    url: "https://www.teloscan.io/"
                }
            },
            contracts: {
                multicall3: {
                    address: "0xcA11bde05977b3631167028862bE2a173976CA11",
                    blockCreated: 246530709
                }
            }
        };
        var telosTestnet = {
            id: 41,
            name: "Telos",
            network: "telosTestnet",
            nativeCurrency: {
                decimals: 18,
                name: "Telos",
                symbol: "TLOS"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://testnet.telos.net/evm"
                    ]
                },
                public: {
                    http: [
                        "https://testnet.telos.net/evm"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "Teloscan (testnet)",
                    url: "https://testnet.teloscan.io/"
                }
            },
            testnet: true
        };
        var zkSync = {
            id: 324,
            name: "zkSync",
            network: "zksync",
            nativeCurrency: {
                decimals: 18,
                name: "Ether",
                symbol: "ETH"
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://zksync2-mainnet.zksync.io"
                    ],
                    webSocket: [
                        "wss://zksync2-mainnet.zksync.io/ws"
                    ]
                },
                public: {
                    http: [
                        "https://zksync2-mainnet.zksync.io"
                    ],
                    webSocket: [
                        "wss://zksync2-mainnet.zksync.io/ws"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "zkExplorer",
                    url: "https://explorer.zksync.io"
                }
            }
        };
        var zkSyncTestnet = {
            id: 280,
            name: "zkSync Testnet",
            network: "zksync-testnet",
            nativeCurrency: {
                name: "Ether",
                symbol: "ETH",
                decimals: 18
            },
            rpcUrls: {
                default: {
                    http: [
                        "https://zksync2-testnet.zksync.dev"
                    ],
                    webSocket: [
                        "wss://zksync2-testnet.zksync.dev/ws"
                    ]
                },
                public: {
                    http: [
                        "https://zksync2-testnet.zksync.dev"
                    ],
                    webSocket: [
                        "wss://zksync2-testnet.zksync.dev/ws"
                    ]
                }
            },
            blockExplorers: {
                default: {
                    name: "zkExplorer",
                    url: "https://goerli.explorer.zksync.io"
                }
            },
            testnet: true
        };
        exports.arbitrum = arbitrum;
        exports.arbitrumGoerli = arbitrumGoerli;
        exports.aurora = aurora;
        exports.auroraTestnet = auroraTestnet;
        exports.avalanche = avalanche;
        exports.avalancheFuji = avalancheFuji;
        exports.baseGoerli = baseGoerli;
        exports.bronos = bronos;
        exports.bronosTestnet = bronosTestnet;
        exports.bsc = bsc;
        exports.bscTestnet = bscTestnet;
        exports.canto = canto;
        exports.celo = celo;
        exports.celoAlfajores = celoAlfajores;
        exports.crossbell = crossbell;
        exports.evmos = evmos;
        exports.evmosTestnet = evmosTestnet;
        exports.fantom = fantom;
        exports.fantomTestnet = fantomTestnet;
        exports.filecoin = filecoin;
        exports.filecoinCalibration = filecoinCalibration;
        exports.filecoinHyperspace = filecoinHyperspace;
        exports.foundry = foundry;
        exports.gnosis = gnosis;
        exports.gnosisChiado = gnosisChiado;
        exports.goerli = goerli;
        exports.hardhat = hardhat;
        exports.harmonyOne = harmonyOne;
        exports.iotex = iotex;
        exports.iotexTestnet = iotexTestnet;
        exports.localhost = localhost;
        exports.mainnet = mainnet;
        exports.metis = metis;
        exports.metisGoerli = metisGoerli;
        exports.moonbaseAlpha = moonbaseAlpha;
        exports.moonbeam = moonbeam;
        exports.moonriver = moonriver;
        exports.okc = okc;
        exports.optimism = optimism;
        exports.optimismGoerli = optimismGoerli;
        exports.polygon = polygon;
        exports.polygonMumbai = polygonMumbai;
        exports.polygonZkEvmTestnet = polygonZkEvmTestnet;
        exports.sepolia = sepolia;
        exports.taraxa = taraxa;
        exports.taraxaTestnet = taraxaTestnet;
        exports.telos = telos;
        exports.telosTestnet = telosTestnet;
        exports.zkSync = zkSync;
        exports.zkSyncTestnet = zkSyncTestnet;
    }
});
// src/connectors/GoogleSocialWalletConnector.tsx
import { GoogleSocialWallet } from "@zerodevapp/social-wallet";
// src/connectors/ZeroDevConnector.tsx
import { Connector } from "wagmi";
import { getZeroDevProvider } from "@zerodevapp/sdk";
// src/services/ZeroDevApiService.tsx
var _ZeroDevApiService = /*#__PURE__*/ function() {
    "use strict";
    function _ZeroDevApiService1() {
        _classCallCheck(this, _ZeroDevApiService1);
    }
    _createClass(_ZeroDevApiService1, null, [
        {
            key: "getProjectConfiguration",
            value: function getProjectConfiguration(projectId) {
                return _asyncToGenerator(function() {
                    var resp;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat(_ZeroDevApiService.baseUrl, "/v1/projects/").concat(projectId), {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json"
                                        }
                                    })
                                ];
                            case 1:
                                resp = _state.sent();
                                return [
                                    4,
                                    resp.json()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return _ZeroDevApiService1;
}();
var ZeroDevApiService = _ZeroDevApiService;
var _process_env_REACT_APP_ZERODEV_BACKEND_URL;
ZeroDevApiService.baseUrl = (_process_env_REACT_APP_ZERODEV_BACKEND_URL = process.env.REACT_APP_ZERODEV_BACKEND_URL) !== null && _process_env_REACT_APP_ZERODEV_BACKEND_URL !== void 0 ? _process_env_REACT_APP_ZERODEV_BACKEND_URL : "https://backend-vikp.onrender.com";
// src/connectors/ZeroDevConnector.tsx
var wagmiChains = __toESM(require_dist());
var ZeroDevConnector = /*#__PURE__*/ function(Connector) {
    "use strict";
    _inherits(ZeroDevConnector, Connector);
    var _super = _createSuper(ZeroDevConnector);
    function ZeroDevConnector(param) {
        var _param_chains = param.chains, chains = _param_chains === void 0 ? [] : _param_chains, options = param.options;
        _classCallCheck(this, ZeroDevConnector);
        var _this;
        _this = _super.call(this, {
            chains: chains,
            options: options
        });
        _this.provider = null;
        _this.id = "zeroDev";
        _this.name = "Zero Dev";
        _this.ready = true;
        _this.zeroDevChains = [];
        return _this;
    }
    _createClass(ZeroDevConnector, [
        {
            key: "connect",
            value: function connect() {
                var chainId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).chainId;
                var _this = this;
                return _asyncToGenerator(function() {
                    var provider, account, id;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.emit("message", {
                                    type: "connecting"
                                });
                                return [
                                    4,
                                    _this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    _this.getAccount()
                                ];
                            case 2:
                                account = _state.sent();
                                return [
                                    4,
                                    _this.getChainId()
                                ];
                            case 3:
                                id = _state.sent();
                                return [
                                    2,
                                    {
                                        account: account,
                                        chain: {
                                            id: id,
                                            unsupported: _this.isChainUnsupported(id)
                                        },
                                        provider: provider
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var _this = this;
                return _asyncToGenerator(function() {
                    return __generator(this, function(_state) {
                        return [
                            2,
                            _this.options
                        ];
                    });
                })();
            }
        },
        {
            key: "getProvider",
            value: function getProvider() {
                var _this = this;
                return _asyncToGenerator(function() {
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.provider === null)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.getOptions()
                                ];
                            case 1:
                                return [
                                    4,
                                    getZeroDevProvider.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                            case 2:
                                _this.provider = _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _this.provider
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isAuthorized",
            value: function isAuthorized() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var account, e;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getAccount()
                                ];
                            case 1:
                                account = _state.sent();
                                return [
                                    2,
                                    !!account
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var options, response;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.provider === null || _this.zeroDevChains.length === 0)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.getOptions()
                                ];
                            case 1:
                                options = _state.sent();
                                return [
                                    4,
                                    ZeroDevApiService.getProjectConfiguration(options.projectId)
                                ];
                            case 2:
                                response = _state.sent();
                                _this.zeroDevChains = Object.values(wagmiChains).filter(function(wagmiChain) {
                                    return wagmiChain.id === response["chainId"];
                                });
                                _state.label = 3;
                            case 3:
                                if (_this.provider === null) {
                                    return [
                                        2,
                                        _this.zeroDevChains[0].id
                                    ];
                                }
                                return [
                                    4,
                                    _this.getProvider()
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent().chainId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSigner",
            value: function getSigner() {
                var _this = this;
                return _asyncToGenerator(function() {
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getProvider()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().getSigner()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccount",
            value: function getAccount() {
                var _this = this;
                return _asyncToGenerator(function() {
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getSigner()
                                ];
                            case 1:
                                return [
                                    4,
                                    _state.sent().getAddress()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isChainUnsupported",
            value: function isChainUnsupported(chainId) {
                if (this.chains.length === 0) {
                    return false;
                }
                return _get(_getPrototypeOf(ZeroDevConnector.prototype), "isChainUnsupported", this).call(this, chainId);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var options;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getOptions()
                                ];
                            case 1:
                                options = _state.sent();
                                _this.provider = null;
                                if (!options.disconnect) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    options.disconnect()
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onAccountsChanged",
            value: function onAccountsChanged(accounts) {}
        },
        {
            key: "onChainChanged",
            value: function onChainChanged() {}
        },
        {
            key: "onDisconnect",
            value: function onDisconnect() {
                this.emit("disconnect");
                this.getOptions().then(function(options) {
                    if (options.disconnect) {
                        options.disconnect();
                    }
                });
            }
        }
    ]);
    return ZeroDevConnector;
}(Connector);
// src/connectors/AbstractSocialWalletConnector.tsx
import { getSocialWalletOwner } from "@zerodevapp/sdk";
var AbstractSocialWalletConnector = /*#__PURE__*/ function(ZeroDevConnector) {
    "use strict";
    _inherits(AbstractSocialWalletConnector, ZeroDevConnector);
    var _super = _createSuper(AbstractSocialWalletConnector);
    function AbstractSocialWalletConnector() {
        _classCallCheck(this, AbstractSocialWalletConnector);
        return _super.apply(this, arguments);
    }
    _createClass(AbstractSocialWalletConnector, [
        {
            key: "getOptions",
            value: function getOptions() {
                var _this = this;
                var _this1 = this, _superprop_get_getOptions = function() {
                    return _get(_getPrototypeOf(AbstractSocialWalletConnector.prototype), "getOptions", _this);
                };
                return _asyncToGenerator(function() {
                    var _tmp;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this1.owner) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    getSocialWalletOwner(_this1.options.projectId, _this1.socialWallet)
                                ];
                            case 1:
                                _this1.owner = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp = [
                                    {}
                                ];
                                return [
                                    4,
                                    _superprop_get_getOptions().call(_this1)
                                ];
                            case 3:
                                return [
                                    2,
                                    _objectSpreadProps.apply(void 0, [
                                        _objectSpread.apply(void 0, _tmp.concat([
                                            _state.sent()
                                        ])),
                                        {
                                            owner: _this1.owner,
                                            disconnect: _this1.socialWallet.disconnect.bind(_this1.socialWallet)
                                        }
                                    ])
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AbstractSocialWalletConnector;
}(ZeroDevConnector);
// src/connectors/GoogleSocialWalletConnector.tsx
var GoogleSocialWalletConnector = /*#__PURE__*/ function(AbstractSocialWalletConnector) {
    "use strict";
    _inherits(GoogleSocialWalletConnector, AbstractSocialWalletConnector);
    var _super = _createSuper(GoogleSocialWalletConnector);
    function GoogleSocialWalletConnector() {
        _classCallCheck(this, GoogleSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "google";
        _this.name = "Google";
        _this.socialWallet = new GoogleSocialWallet();
        return _this;
    }
    return GoogleSocialWalletConnector;
}(AbstractSocialWalletConnector);
// src/integrations/rainbowkit/wallets/googleWallet.tsx
function googleWallet(param) {
    var options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/2048px-Google_%22G%22_Logo.svg.png",
        id: "google",
        name: "Google",
        createConnector: function() {
            return {
                connector: new GoogleSocialWalletConnector({
                    options: options
                })
            };
        }
    };
}
// src/connectors/TwitterSocialWalletConnector.tsx
import { TwitterSocialWallet } from "@zerodevapp/social-wallet";
var TwitterSocialWalletConnector = /*#__PURE__*/ function(AbstractSocialWalletConnector) {
    "use strict";
    _inherits(TwitterSocialWalletConnector, AbstractSocialWalletConnector);
    var _super = _createSuper(TwitterSocialWalletConnector);
    function TwitterSocialWalletConnector() {
        _classCallCheck(this, TwitterSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "twitter";
        _this.name = "Twitter";
        _this.socialWallet = new TwitterSocialWallet();
        return _this;
    }
    return TwitterSocialWalletConnector;
}(AbstractSocialWalletConnector);
// src/integrations/rainbowkit/wallets/twitterWallet.tsx
function twitterWallet(param) {
    var options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://cdn3.iconfinder.com/data/icons/inficons/512/twitter.png",
        id: "openlogin_twitter",
        name: "Twitter",
        createConnector: function createConnector() {
            return {
                connector: new TwitterSocialWalletConnector({
                    options: options
                })
            };
        }
    };
}
// src/connectors/TwitchSocialWalletConnector.tsx
import { TwitchSocialWallet } from "@zerodevapp/social-wallet";
var TwitchSocialWalletConnector = /*#__PURE__*/ function(AbstractSocialWalletConnector) {
    "use strict";
    _inherits(TwitchSocialWalletConnector, AbstractSocialWalletConnector);
    var _super = _createSuper(TwitchSocialWalletConnector);
    function TwitchSocialWalletConnector() {
        _classCallCheck(this, TwitchSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "twitch";
        _this.name = "Twitch";
        _this.socialWallet = new TwitchSocialWallet();
        return _this;
    }
    return TwitchSocialWalletConnector;
}(AbstractSocialWalletConnector);
// src/integrations/rainbowkit/wallets/twitchWallet.tsx
function twitchWallet(param) {
    var options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://cdn4.iconfinder.com/data/icons/logos-brands-7/512/twitch-1024.png",
        id: "openlogin_twitch",
        name: "Twitch",
        createConnector: function createConnector() {
            return {
                connector: new TwitchSocialWalletConnector({
                    options: options
                })
            };
        }
    };
}
// src/connectors/FacebookSocialWalletConnector.tsx
import { FacebookSocialWallet } from "@zerodevapp/social-wallet";
var FacebookSocialWalletConnector = /*#__PURE__*/ function(AbstractSocialWalletConnector) {
    "use strict";
    _inherits(FacebookSocialWalletConnector, AbstractSocialWalletConnector);
    var _super = _createSuper(FacebookSocialWalletConnector);
    function FacebookSocialWalletConnector() {
        _classCallCheck(this, FacebookSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "facebook";
        _this.name = "Facebook";
        _this.socialWallet = new FacebookSocialWallet();
        return _this;
    }
    return FacebookSocialWalletConnector;
}(AbstractSocialWalletConnector);
// src/integrations/rainbowkit/wallets/facebookWallet.tsx
function facebookWallet(param) {
    var options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://cdn2.iconfinder.com/data/icons/social-icons-33/128/Facebook-512.png",
        id: "openlogin_facebook",
        name: "Facebook",
        createConnector: function createConnector() {
            return {
                connector: new FacebookSocialWalletConnector({
                    options: options
                })
            };
        }
    };
}
// src/connectors/GithubSocialWalletConnector.tsx
import { GithubSocialWallet } from "@zerodevapp/social-wallet";
var GithubSocialWalletConnector = /*#__PURE__*/ function(AbstractSocialWalletConnector) {
    "use strict";
    _inherits(GithubSocialWalletConnector, AbstractSocialWalletConnector);
    var _super = _createSuper(GithubSocialWalletConnector);
    function GithubSocialWalletConnector() {
        _classCallCheck(this, GithubSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "github";
        _this.name = "Github";
        _this.socialWallet = new GithubSocialWallet();
        return _this;
    }
    return GithubSocialWalletConnector;
}(AbstractSocialWalletConnector);
// src/integrations/rainbowkit/wallets/githubWallet.tsx
function githubWallet(param) {
    var options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/142_Github_logo_logos-512.png",
        id: "openlogin_github",
        name: "Github",
        createConnector: function createConnector() {
            return {
                connector: new GithubSocialWalletConnector({
                    options: options
                })
            };
        }
    };
}
// src/connectors/DiscordSocialWalletConnector.tsx
import { DiscordSocialWallet } from "@zerodevapp/social-wallet";
var DiscordSocialWalletConnector = /*#__PURE__*/ function(AbstractSocialWalletConnector) {
    "use strict";
    _inherits(DiscordSocialWalletConnector, AbstractSocialWalletConnector);
    var _super = _createSuper(DiscordSocialWalletConnector);
    function DiscordSocialWalletConnector() {
        _classCallCheck(this, DiscordSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "discord";
        _this.name = "Discord";
        _this.socialWallet = new DiscordSocialWallet();
        return _this;
    }
    return DiscordSocialWalletConnector;
}(AbstractSocialWalletConnector);
// src/integrations/rainbowkit/wallets/discordWallet.tsx
function discordWallet(param) {
    var options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/91_Discord_logo_logos-512.png",
        id: "openlogin_discord",
        name: "Discord",
        createConnector: function createConnector() {
            return {
                connector: new DiscordSocialWalletConnector({
                    options: options
                })
            };
        }
    };
}
// src/utilities/enhanceConnectorWithAA.tsx
import { getZeroDevProvider as getZeroDevProvider2, getRPCProviderOwner } from "@zerodevapp/sdk";
var enhanceConnectorWithAA = function(connector, params) {
    var provider = null;
    var enhancedConnector = new Proxy(connector, {
        get: function get(target, prop, receiver) {
            if (prop === "switchChain") return void 0;
            var value = target[prop];
            if (_instanceof(value, Function)) {
                return /*#__PURE__*/ _asyncToGenerator(function() {
                    var _len, args, _key, source, _tmp, _tmp1, response;
                    var _arguments = arguments;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                    args[_key] = _arguments[_key];
                                }
                                return [
                                    4,
                                    value.apply(target, args)
                                ];
                            case 1:
                                source = _state.sent();
                                switch(prop){
                                    case "connect":
                                        return [
                                            3,
                                            2
                                        ];
                                    case "getChainId":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "getProvider":
                                        return [
                                            3,
                                            8
                                        ];
                                    case "getSigner":
                                        return [
                                            3,
                                            11
                                        ];
                                    case "getAccount":
                                        return [
                                            3,
                                            14
                                        ];
                                    case "disconnect":
                                        return [
                                            3,
                                            17
                                        ];
                                }
                                return [
                                    3,
                                    18
                                ];
                            case 2:
                                _tmp = [
                                    _objectSpread({}, source)
                                ];
                                _tmp1 = {};
                                return [
                                    4,
                                    receiver.getAccount()
                                ];
                            case 3:
                                return [
                                    2,
                                    _objectSpreadProps.apply(void 0, _tmp.concat([
                                        (_tmp1.account = _state.sent(), _tmp1)
                                    ]))
                                ];
                            case 4:
                                if (!(provider === null)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    ZeroDevApiService.getProjectConfiguration(params.projectId)
                                ];
                            case 5:
                                response = _state.sent();
                                return [
                                    2,
                                    response["chainId"]
                                ];
                            case 6:
                                return [
                                    4,
                                    receiver.getProvider()
                                ];
                            case 7:
                                return [
                                    2,
                                    _state.sent().chainId
                                ];
                            case 8:
                                if (!(provider === null)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    getZeroDevProvider2(_objectSpreadProps(_objectSpread({}, params), {
                                        owner: getRPCProviderOwner(source)
                                    }))
                                ];
                            case 9:
                                provider = _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    2,
                                    provider
                                ];
                            case 11:
                                return [
                                    4,
                                    receiver.getProvider()
                                ];
                            case 12:
                                return [
                                    4,
                                    _state.sent().getSigner()
                                ];
                            case 13:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 14:
                                return [
                                    4,
                                    receiver.getSigner()
                                ];
                            case 15:
                                return [
                                    4,
                                    _state.sent().getAddress()
                                ];
                            case 16:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 17:
                                provider = null;
                                _state.label = 18;
                            case 18:
                                return [
                                    2,
                                    source
                                ];
                            case 19:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
            return value;
        }
    });
    var onAccountsChanged = enhancedConnector["onAccountsChanged"];
    enhancedConnector["onAccountsChanged"] = function() {
        provider = null;
        enhancedConnector.getAccount().then(function(account) {
            return onAccountsChanged([
                account
            ]);
        });
    };
    enhancedConnector["onChainChanged"] = function() {};
    var onDisconnect = enhancedConnector["onDisconnect"];
    enhancedConnector["onDisconnect"] = function(error) {
        provider = null;
        onDisconnect(error);
    };
    return enhancedConnector;
};
// src/integrations/rainbowkit/enhanceWalletWithAAConnector.tsx
var enhanceWalletWithAAConnector = function(wallet, params) {
    return new Proxy(wallet, {
        get: function get(target, prop, receiver) {
            var source = Reflect.get(target, prop, receiver);
            if (prop === "createConnector") {
                return function() {
                    var result = source();
                    return _objectSpreadProps(_objectSpread({}, result), {
                        connector: enhanceConnectorWithAA(result["connector"], params)
                    });
                };
            }
            return source;
        }
    });
};
export { discordWallet, enhanceWalletWithAAConnector, facebookWallet, githubWallet, googleWallet, twitchWallet, twitterWallet };
